import {Layout, Menu, MenuProps} from 'antd';
import {Navigate, NavLink, Route, Routes, useLocation} from 'react-router-dom';
import Station from './stations/Stations';
import Groups from './stationGroups/StationGroups';
import {useAppSelector} from '../../../common/hooks';
type MenuItem = Required<MenuProps>['items'][number];

const {Header, Content} = Layout;

const Main = () => {
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const items: MenuItem[] = [
    userPermission.show_station
      ? {label: <NavLink to={'stations'}>Stations</NavLink>, key: 'stations'}
      : null,
    userPermission.show_stationgroup
      ? {label: <NavLink to={'groups'}>Groups</NavLink>, key: 'groups'}
      : null,
  ];

  return (
    <Layout style={{height: '100%', backgroundColor: '#fff'}}>
      <Header
        style={{
          backgroundColor: '#fff',
          alignItems: 'center',
          paddingInline: '00px',
          height: '48px',
          marginBottom: '10px',
          borderBottom: '1px solid #00000022',
        }}
      >
        <Menu
          mode='horizontal'
          theme='light'
          selectedKeys={[useLocation().pathname.split('/')[3]]}
          style={{
            backgroundColor: 'transparent',
            border: '0px',
            lineHeight: '40px',
          }}
          items={items}
        />
      </Header>
      <Content>
        {/* <h1>asdad</h1> */}
        <Routes>
          {userPermission.show_station && <Route path='/stations' element={<Station />} />}
          <Route
            path='/'
            element={
              userPermission.show_station ? (
                <Navigate to={'stations'} />
              ) : (
                <Navigate to={'groups'} />
              )
            }
          />
          {userPermission.show_stationgroup && <Route path='/groups' element={<Groups />} />}
          <Route path='/*' element={<Navigate to={'/404/'} />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default Main;
